export const HEADER_WRAPPER_ID = 'headerWrapper';
